import { SessionService } from '@thoughtspot/session-service';

export const isLeftPanelVisible = (
    isOverlayPanel: boolean,
    isGlobalNavHidden: boolean,
    isNavigationV3Enabled: boolean,
    isInsightsPage: boolean,
    sessionService: SessionService,
) => {
    return (
        !isOverlayPanel &&
        !isGlobalNavHidden &&
        !(
            sessionService.hideHomepageLeftNav(isNavigationV3Enabled) &&
            isInsightsPage
        )
    );
};
